const map = {
	"./android-chrome-192x192.png": 11864,
	"./android-chrome-512x512.png": 60208,
	"./apple-touch-icon.png": 97695,
	"./favicon-16x16.png": 40466,
	"./favicon-32x32.png": 35174,
	"./favicon.ico": 62261,
	"./favicon.svg": 83284,
	"./safari-pinned-tab.svg": 27597,
	"./site.webmanifest": 76426
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70088;